import { Snackbar, Alert } from '@mui/material';

export default function AppSnackbar({ open, message, severity = 'success', onClose, duration = 4000 }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ borderRadius: 3, minWidth: 300 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
